import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesApplyLeaveForm {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
   if(webcontext.ConfigType.toLowerCase()=="form" && webcontext.OpType.toLowerCase()=="add"){//插入数据时
    //  console.log(11010111);
    let request = JSON.parse(webcontext.RequestBody);
    let datepie:DatePipe =new DatePipe("en-US");
    if(typeof(request.a_FK_TypeOfLeave_ID)=="undefined"){
      webcontext.ResponseMessage.ErrorMessage="请假类型必选";
      webcontext.ResponseMessage.Success =false;
    }else if(typeof(request.a_Remarks)=="undefined"){
      webcontext.ResponseMessage.ErrorMessage="请假说明必填";
      webcontext.ResponseMessage.Success =false;
    }else if(typeof(request.a_ShenPiRen)=="undefined"){
      webcontext.ResponseMessage.ErrorMessage=" 上级审批人不能为空";
      webcontext.ResponseMessage.Success =false;
    }
    else 
    if(typeof(request.a_startDate)=="undefined" && typeof(request.a_endDate)=="undefined"){
      webcontext.ResponseMessage.ErrorMessage=" 请假时间不能为空";
      webcontext.ResponseMessage.Success =false;
    }else if(request.a_startDate && request.a_endDate){
      // var oDate1 = new Date(request.a_startDate.replace(/-/g,"/"));//开始日期
      // var oDate2 = new Date(request.a_endDate.replace(/-/g,"/"));//结束日期
      var oDate1 = new Date(request.a_startDate);//开始日期
      var oDate2 = new Date(request.a_endDate);//结束日期
      // var data = new Date();//现在时间
      // if(oDate1.getTime()<data.getTime()){
      //   webcontext.ResponseMessage.ErrorMessage="开始日期不能小于当前时间";
      //   webcontext.ResponseMessage.Success =false;
      // }else
      const num1:number = oDate2.getTime();
      const num2:number = oDate1.getTime();
      if((num1-num2)<=0){
        webcontext.ResponseMessage.ErrorMessage="结束时间不能小于等于开始时间";
        webcontext.ResponseMessage.Success =false;
      } else{
        // request.a_startDate = datepie.transform(request.a_startDate,"yyyy-MM-dd HH:mm:ss");
        // request.a_endDate = datepie.transform(request.a_endDate,"yyyy-MM-dd HH:mm:ss");
        request.a_startDate = request.a_startDate.replace("T"," ").replace("Z",'').replace("-00:00",'');
        request.a_endDate = request.a_endDate.replace("T"," ").replace("Z",'').replace("-00:00",'');
      }
    }
    request["a_Code"]=datepie.transform(new Date(),"yyyyMMddHHmmss");
    request["a_FK_SystemUser_ID"]=webcontext.Account.Id;
   //  console.log(request);
    if(request.a_ShenPiRen){
        let chanec=request.a_ShenPiRen;
        delete request.a_ShenPiRen;
 
    let t= Object.assign(request,chanec);
   //  consle.log(t);
   // let repone ={"a_AuditStatus":"0","CHILDOBJ_TypeOfLeaveSysUserXML":{"Datas":[{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"},{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"}],"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"}},"a_StartDate":"2019-03-11 23:59:59","a_EndDate":"2019-03-13 23:59:59","a_LeaveLength":"10","a_Remarks":"sadfasdasdasd"};
    webcontext.RequestBody = JSON.stringify(t);
    }
    // webcontext.ResponseMessage.Success = false;
    // webcontext.ResponseMessage.ErrorMessage = "停下来";
   }
  // console.log("1008611");

    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
    const that = this;
    if(webParameterContext.ConfigType.toLowerCase()=="form"){
     if(webContext.ResponseMessage.Success){
      let datepie:DatePipe =new DatePipe("en-US");
          if(webContext.Other){
           webContext.Other.Success=true;
            webContext.url="/tabs/contact/LeaveReport/type/"+datepie.transform(new Date(),"yyyyMMddHHmmss");
          }else{
           webContext.Other={"Success":true,"url":"/tabs/contact/LeaveReport/type/"+datepie.transform(new Date(),"yyyyMMddHHmmss")};
          }
     }
    
     // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
     // webContext.ResponseMessage.Success=false;
    }
   
    return webContext
  }
  

}